import Hero from '@/pages/home/components/Hero';
import HomeAbout from '@/pages/home/components/HomeAbout';
import LabVideoSection from '@/pages/home/components/LabVideoSection';
import Stats from '@/pages/home/components/Stats';
import FeaturedProducts from '@/pages/home/components/FeaturedProducts';
import ImpactBanner from '@/pages/home/components/ImpactBanner';
import ImageSlider from '@/pages/home/components/ImageSlider';
import FieldVideoSection from '@/pages/home/components/FieldVideoSection';
import VideoDemo from '@/pages/home/components/VideoDemo';
import QuickQuote from '@/pages/home/components/QuickQuote';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Hero />
      <HomeAbout />
      <LabVideoSection />
      <Stats />
      <FeaturedProducts />
      <ImpactBanner />
      <ImageSlider />
      <FieldVideoSection />
      <VideoDemo />
      <QuickQuote />
    </main>
  );
}